import { render, staticRenderFns } from "./tagRelationList.vue?vue&type=template&id=1c095422&scoped=true"
import script from "./tagRelationList.vue?vue&type=script&setup=true&lang=js"
export * from "./tagRelationList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tagRelationList.vue?vue&type=style&index=0&id=1c095422&prod&lang=scss"
import style1 from "./tagRelationList.vue?vue&type=style&index=1&id=1c095422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c095422",
  null
  
)

export default component.exports